module.exports = __webpack_public_path__ + "img/green.06da0027.jpg";